import React from 'react';
import { Router } from 'react-router-dom';
import {
	CompatRouter,
	Navigate,
	Routes as RouterRoutes,
	Route,
	useLocation,
} from 'react-router-dom-v5-compat';
import { isLocal } from 'stash/utils';
import { lazyLoad } from 'stash/utils/lazy';
import { LocationChangeDispatcher } from 'stash/components/global/LocationChangeDispatcher';

const AsyncOnboardingApp = lazyLoad(
	() => import('stash/apps/onboarding/OnboardingAppWithBootstrap')
);

const AsyncPageNotFound404 = lazyLoad(
	() => import('stash/components/screens/404-page/PageNotFound404')
);

const AsyncLinkPlaidOAuth = lazyLoad(
	() => import('stash/components/screens/payment-source/plaidv2/LinkPlaidOAuth')
);

const AsyncInternalAuthPage = lazyLoad(
	() => import('stash/components/screens/authorize/Authorize')
);

const AsyncSmartPortfolioReconfirmationScreen = lazyLoad(
	() =>
		import('stash/components/screens/smart-portfolio-reconfirmation-screen/SmartPortfolioReconfirmationScreen')
);

const AsyncPublicWelcomeScreen = lazyLoad(
	() => import('stash/components/screens/public-welcome-screen/PublicWelcomeScreen')
);

const AsyncStockPartyApp = lazyLoad(
	() => import('stash/components/screens/stock-party/StockPartyContainer')
);
// Helper component for /web/* redirect that needs access to location
const WebRedirect = () => {
	const location = useLocation();
	return <Navigate to={location.pathname.replace('/web', '') + location.search} replace />;
};

export const Routes = ({ history }) => {
	return (
		<Router history={history}>
			<CompatRouter>
				<LocationChangeDispatcher />
				<RouterRoutes>
					<Route path="/web/*" element={<WebRedirect />} />
					<Route
						path="/"
						element={<Navigate to={`/sign-up/get-started${window.location.search}`} replace />}
					/>
					<Route
						path="/sign-up"
						element={<Navigate to={`/sign-up/get-started${window.location.search}`} replace />}
					/>
					<Route path="/sign-up/get-started" element={<AsyncOnboardingApp />} />
					<Route
						path="/sign-up-purchase"
						element={
							<Navigate to={`/sign-up-purchase/get-started${window.location.search}`} replace />
						}
					/>
					<Route
						path="/sign-up-retire"
						element={
							<Navigate to={`/sign-up-retire/get-started${window.location.search}`} replace />
						}
					/>
					<Route
						path="/sign-up/set-schedule/reconfirm-smart-success"
						element={<AsyncSmartPortfolioReconfirmationScreen />}
					/>
					{isLocal() && <Route path="/authorize" element={<AsyncInternalAuthPage />} />}
					<Route path="/oauth/plaid/*" element={<AsyncLinkPlaidOAuth />} />
					<Route path="/sign-up-:product/get-started" element={<AsyncOnboardingApp />} />
					<Route path="/sign-up/welcome" element={<AsyncPublicWelcomeScreen />} />
					<Route
						path="/sign-up/your-plan"
						element={<Navigate to={`/sign-up/welcome${window.location.search}`} replace />}
					/>
					<Route path="/sign-up/stock-party/*" element={<AsyncStockPartyApp />} />
					<Route path="/sign-up-:product/*" element={<AsyncOnboardingApp />} />
					<Route path="/sign-up/*" element={<AsyncOnboardingApp />} />
					<Route path="*" element={<AsyncPageNotFound404 />} />
				</RouterRoutes>
			</CompatRouter>
		</Router>
	);
};

export default Routes;
